export default "__VITE_ASSET__ChzKKlaK__"